// src/components/ui/FeatureCard.jsx
import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

const FeatureCard = ({
    icon,               // Objeto de FontAwesomeIcon (directamente)
    iconSize = "2x",
    // iconColorClass ya no es tan necesario aquí porque el div padre tiene text-white
    iconContainerClass = "icon-circle bg-success text-white mb-3 mx-auto", // Clases para el div del ícono

    title,
    text,

    cardClassName = "h-100 text-center shadow-sm border-0 p-3", // Clases de la tarjeta
    titleAs = "h3", // El 'as' prop para Card.Title
    titleClassName = "fw-bold fs-5 mb-3", // Clases del título
    textClassName = "text-muted small",  // Clases del texto

    children, // Para cualquier contenido adicional si se necesita
    ...restCardProps // Para pasar otras props al componente Card de Bootstrap
}) => {
    return (
        <Card className={`feature-card-reusable ${cardClassName}`} {...restCardProps}>
            <Card.Body className="d-flex flex-column">
                {icon && (
                    <div className={iconContainerClass}>
                        <FontAwesomeIcon icon={icon} size={iconSize} />
                        {/* Si necesitas un color específico para el icono que no sea el del text-white del contenedor:
                        <FontAwesomeIcon icon={icon} size={iconSize} className="tu-clase-de-color-de-icono" /> 
                        Pero text-white en iconContainerClass debería ser suficiente */}
                    </div>
                )}
                {title && <Card.Title as={titleAs} className={titleClassName}>{title}</Card.Title>}
                {text && <Card.Text className={`${textClassName} flex-grow-1`}>{text}</Card.Text>}
                {children}
            </Card.Body>
        </Card>
    );
};

FeatureCard.propTypes = {
    icon: PropTypes.object.isRequired, // Se espera un objeto de ícono de FontAwesome
    iconSize: PropTypes.string,
    iconContainerClass: PropTypes.string,
    title: PropTypes.string.isRequired,
    text: PropTypes.string,
    cardClassName: PropTypes.string,
    titleAs: PropTypes.string,
    titleClassName: PropTypes.string,
    textClassName: PropTypes.string,
    children: PropTypes.node,
};

export default FeatureCard;